import update from "immutability-helper";
import PropTypes from "prop-types";
import React from "react";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import { TickerView } from "..";
import Box from "../layout/Box";

class TickerSeriesView extends React.Component {
  static propTypes = {
    tickers: PropTypes.array.isRequired,
    onTickerDelete: PropTypes.func.isRequired,
    onReorder: PropTypes.func.isRequired,
    onTickerChange: PropTypes.func.isRequired,
    onTickerAdd: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { tickers: props.tickers };
  }

  componentWillReceiveProps(newProps) {
    if (this.props.tickers !== newProps.tickers) {
      this.setState({ tickers: newProps.tickers });
    }
  }

  handleClone = (ticker) => {
    this.props.onTickerAdd(ticker);
  };

  handleDrop = () => {
    this.props.onReorder(this.state.tickers);
  };

  handleSave = (ticker) => {
    this.props.onTickerChange(ticker);
  };

  moveItem = (dragIndex, hoverIndex) => {
    const { tickers } = this.state;
    const dragItem = tickers[dragIndex];

    this.setState(
      update(this.state, {
        tickers: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragItem],
          ],
        },
      })
    );
  };

  render() {
    const { tickers } = this.state;

    return (
      <Box direction="column">
        {tickers.map((item, index) => (
          <TickerView
            key={item.id}
            index={index}
            ticker={item}
            moveItem={this.moveItem}
            dropItem={this.handleDrop}
            onSave={this.handleSave}
            onClone={this.handleClone}
            onTickerDelete={this.props.onTickerDelete}
          />
        ))}
      </Box>
    );
  }
}

export default TickerSeriesView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/TickerSeriesView/index.js